
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "whats-new-in-apache-atlas-22"
    }}>{`What's new in Apache Atlas 2.2?`}</h1>
    <h2 {...{
      "id": "features"
    }}>{`Features`}</h2>
    <ul>
      <li parentName="ul"><strong parentName="li">{`(new) Deferred Action`}</strong>{`: classification propagation will be handled as a background task (AtlasTask)`}</li>
      <li parentName="ul"><strong parentName="li">{`Re-indexing`}</strong>{`: added Re-indexing as part of JAVA_PATCH`}</li>
      <li parentName="ul"><strong parentName="li">{`Model Change`}</strong>{`: created JAVA_PATCH to add new super types to existing entities`}</li>
      <li parentName="ul"><strong parentName="li">{`Export Service`}</strong>{`: added support for Business Metadata in Atlas Export API`}</li>
      <li parentName="ul"><strong parentName="li">{`Admin/AtlasTask API`}</strong>{`: added HA support for admin/task API`}</li>
      <li parentName="ul"><strong parentName="li">{`Entity definition`}</strong>{`: provided option to add mandatory attribute to existing entity definition`}</li>
    </ul>
    <h2 {...{
      "id": "enhancements"
    }}>{`Enhancements`}</h2>
    <ul>
      <li parentName="ul"><strong parentName="li">{`DSL Search`}</strong>{`:`}
        <ul parentName="li">
          <li parentName="ul">{`added support for glossary terms and relationship`}</li>
          <li parentName="ul">{`added support for null attribute values,`}</li>
          <li parentName="ul">{`now uses Tinkerpop GraphTraversal instead of GremlinScriptEngine for performance improvement`}</li>
          <li parentName="ul">{`added support search by classification and its attribute`}</li>
          <li parentName="ul">{`added caching mechanism for translated DSL queries`}</li>
        </ul>
      </li>
      <li parentName="ul"><strong parentName="li">{`Atlas Python Client`}</strong>{`: refactored and enhanced Atlas Python Client supporting Python 2.7`}</li>
      <li parentName="ul"><strong parentName="li">{`Search`}</strong>{`: updated free-text search processor to support Elasticsearch, Support search text with special characters, optimized pagination`}</li>
      <li parentName="ul"><strong parentName="li">{`Bulk Glossary Import`}</strong>{`: improved and enhanced Bulk Glossary Import supporting import with relations`}</li>
      <li parentName="ul"><strong parentName="li">{`Performance`}</strong>{`: improved performance of GraphHelper's guid and status getter methods`}</li>
      <li parentName="ul"><strong parentName="li">{`Authorization`}</strong>{`: enhanced Atlas authorization for Add/Update/Remove classification on entities, "admin-audits" for Atlas Admin Audits authorization`}</li>
      <li parentName="ul"><strong parentName="li">{`Notification`}</strong>{`: improved NotificationHookConsumer for Large Message Processing`}</li>
      <li parentName="ul"><strong parentName="li">{`Export/Import Service`}</strong>{`: enhanced Export/Import Service to conditionally Support Simultaneous Operations and to export Terms`}</li>
      <li parentName="ul"><strong parentName="li">{`Hive Hook`}</strong>{`: added support HiveServer2 Hook to send Lineage-only Messages`}</li>
      <li parentName="ul"><strong parentName="li">{`Apache Flink`}</strong>{`: introduced model to capture Apache Flink entities and relationships`}</li>
      <li parentName="ul"><strong parentName="li">{`GCP`}</strong>{`: introduced model to capture GCP entities and relationships`}</li>
      <li parentName="ul"><strong parentName="li">{`ADLS-Gen2`}</strong>{`: updated model for Azure Data Lake Storage Gen2 entities and relationships`}</li>
      <li parentName="ul"><strong parentName="li">{`Dependencies Upgrade`}</strong>{`: JanusGraph, elasticsearch, JQuery, Http core, Http Client, slf4j, log4j, ant, gremlin, Solr, groovy, netty, Kafka`}</li>
      <li parentName="ul"><strong parentName="li">{`UI`}</strong>{`: fixed Atlas Web UI to load faster in case of large number of classifications & entities`}</li>
      <li parentName="ul"><strong parentName="li">{`Docker image`}</strong>{`: improvements to Docker support`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://issues.apache.org/jira/issues/?jql=project%20%3D%20ATLAS%20AND%20status%20%3D%20Resolved%20AND%20fixVersion%20%3D%202.2.0%20ORDER%20BY%20key%20DESC"
        }}>{`List of JIRAs resolved in Apache Atlas 2.2.0 release`}</a></li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;